import React from 'react'
import styled from 'styled-components'
import { formatDate } from "@utils";
import { ButtonComponent } from "@components/patterns/elements/Button";
import TitleNoteCommon from '../../home/generate/TitleNoteCommon';
import { Controller } from 'react-hook-form';
import { Input } from 'reactstrap';
import { UploadComponent } from '../../ReferenceMedia/ModalMedia/UploadCustom';

const WrapResult = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* height: calc(100vh - 120px);
  overflow-y: scroll;
  padding-right: 8px;
  padding-bottom: 20px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #D6DBE3; 
    border-radius: 8px;
  } */

  .question-result {
    display: flex;
    flex-direction: column;
    gap: 16px;
    &__question {
      h1 {
        font-size: 20px;
        font-weight: 600;
        line-height: 26px;
        margin-bottom: 12px;
      }
      p {
        font-size: 16px;
        font-weight: 600;
        border-radius: 6px;
        border: 1px solid #D0D5DD;
        padding: 12px;
        &:hover {
          background: #F2F4F7;
        }
        &:focus {
          box-shadow: 0px 0px 0px 2px #006E9B1F;
          border: 1px solid #0089C2;
        }
      }
    }
    &__list {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  .question-media {
    p {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 8px;
    }
    .media-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .text-link {
      color: #1570EF;
      font-size: 16px;
      font-weight: 400;
      text-decoration-line: underline;
      overflow: hidden !important;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  }

  .question-explanation {
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #D0D5DD;
    &:hover {
      background: #F2F4F7;
    }
    &:focus,
    &:focus-within {
      box-shadow: 0px 0px 0px 2px #006E9B1F;
      border: 1px solid #0089C2;
    }
    p {
      color: #101828;
      font-size: 16px;
      font-weight: 700;
    }
    span {
      color: #1D2939;
      font-size: 16px;
      font-weight: 400;
      padding: 4px;
      border-radius: 8px;
      border: 1px solid transparent;
    }
  }
  .text-created {
    color: #848C97;
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
  }
  .formFreeText__form-button {
    width: max-content;
  }
`

const WrapImage = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  .wrap-img {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
    img {
      width: 100%;
      height: 200px;
      object-fit: contain;
    }
  }
  .wrap-upload {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
    .text-note {
      font-size: 14px;
    }
  }
`

export default function ResultFreeText(props) {
  const { dataAnalyze, type, permission, control, watch, dataFileImported, setDataFileImported } = props

  return (
    <WrapResult>
      <div className="formFreeText__form">
        <div className="formFreeText__form-input">
          <div className='input-form'>
            <TitleNoteCommon title="Question Text" required/>
            <Controller
              name="question"
              control={control}
              disabled={(type === "review" || type === "final" || (type === "org" && !permission)) ? true : false}
              render={({ field }) => (
                <Input
                  type='textarea'
                  name='question'
                  placeholder="Write your question here."
                  style={{ height: '200px' }}
                  {...field}
                />
              )}
            />
          </div>
          <div className='input-form'>
            <TitleNoteCommon title="Model Answer"/>
            <Controller
              name="answer"
              disabled={(type === "review" || type === "final" || (type === "org" && !permission)) ? true : false}
              control={control}
              render={({ field }) => (
                <Input
                  type='textarea'
                  name='answer'
                  placeholder="(Optional) Provide grading criteria or a scoring guide for evaluation. "
                  style={{ height: '150px' }}
                  {...field}
                />
              )}
            />
          </div>
          <div className='input-form'>
            <TitleNoteCommon title="Rubrics"/>
            <Controller
              name="rubrics"
              disabled={(type === "review" || type === "final" || (type === "org" && !permission)) ? true : false}
              control={control}
              render={({ field }) => (
                <Input
                  type='textarea'
                  name='rubrics'
                  placeholder="(Optional) Provide an ideal answer for this question."
                  style={{ height: '150px' }}
                  {...field}
                />
              )}
            />
          </div>
        </div>
      </div>
      <WrapImage>
        {dataAnalyze?.Media && (
          <div className='wrap-img'>
            <TitleNoteCommon title="Media"/>
            <img src={dataAnalyze?.Media?.url} alt={dataAnalyze?.Media?.url}/>
          </div>
        )}
        {!(type === "review" || type === "final" || (type === "org" && !permission)) && (
          <div className='wrap-upload'>
            <TitleNoteCommon title={dataAnalyze?.Media ? "Change Media" : "Media"}/>
            <UploadComponent
              dataFileImported={dataFileImported}
              setDataFileImported={setDataFileImported}
              typeUpload="JPG/JPEG, PNG. Max: 10 MB."
              typeFile={["image/png", "image/jpeg"]}
              errorFile="Only JPG/JPEG, PNG files are allowed."
            />
            <p className='text-note'>Click "Save" to apply your changes.</p>
          </div>
        )}
      </WrapImage>
      {((type !== "review" && type !== "final" && type !== "org") || (type === "org" && permission )) && (
        <div className='d-flex justify-content-end'>
          <ButtonComponent form='form-free-text' className={`${!watch("question") ? "disabled" : ""} formFreeText__form-button px-4`} size="small" type="submit">Save</ButtonComponent>
        </div>
      )}
      <div>
        <p className='text-created'>Created at {formatDate(dataAnalyze?.CreatedAt)}</p>
        <p className='text-created'>Last modified at {formatDate(dataAnalyze?.UpdatedAt)}</p>
      </div>
    </WrapResult>
  )
}
